export default "__VITE_ASSET__7b6417c5__"